import { createSlice } from '@reduxjs/toolkit';

export interface ipData {
  country: string;
  city: string;
  state: string;
}
export interface IpState {
  ipData: ipData;
}

const initialItem: ipData = {
  country: '',
  city: '',
  state: '',
};
const initialState: IpState = {
  ipData: initialItem,
};

const ipSlice = createSlice({
  name: 'ip',
  initialState,
  reducers: {
    setIp(_state, action) {
      return action.payload;
    },
  },
});

export const { setIp } = ipSlice.actions;

export default ipSlice.reducer;
